module.exports = __webpack_public_path__ + "static/media/grid-1.f89d5f8b.svg";